import type { FitnessRadarPreviousScores } from "@components/fitness/RadarChart/types";
import type { FitnessScoreCardProps } from "./types";

function clampScore(value: number): number {
  return Math.max(0, Math.min(100, value));
}

/**
 * Chat FitnessScoreCard 雷达旧值：`previous = score - delta`。
 * 全维度 delta 为 0 时返回 null（不画虚线，避免与当前重合）。
 */
export function derivePreviousRadarScores(
  dimensions: FitnessScoreCardProps["dimensions"],
): FitnessRadarPreviousScores | null {
  const { control, safety, growth } = dimensions;
  if (control.delta === 0 && safety.delta === 0 && growth.delta === 0) {
    return null;
  }

  return {
    control: clampScore(control.score - control.delta),
    safety: clampScore(safety.score - safety.delta),
    growth: clampScore(growth.score - growth.delta),
  };
}
